import { FC } from 'react';
import { Box, BoxProps, styled } from '@mui/material';
import { usePrintContext } from '../hooks/usePrint';

interface TabPanelProps extends BoxProps {
    children?: React.ReactNode;
    index: number | string;
    value: number | string;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...boxProps } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
            {value === index && (
                <Box sx={{ paddingTop: 3 }} {...boxProps}>
                    {children}
                </Box>
            )}
        </div>
    );
};

const OffsetTabPanel: FC<TabPanelProps> = styled((props: TabPanelProps): React.JSX.Element => {
    const { print } = usePrintContext();

    return (
        <TabPanel
            // Negative top margin offset to be inline with view button group
            sx={{ mt: print ? 0 : -6.5 }}
            {...props}
        />
    );
})(({ theme }) => ({}));

export type { TabPanelProps };
export { OffsetTabPanel };
export default TabPanel;
